export enum SubElementType {
  Description = 'description',
  Row = 'row',
  RowItem = 'rowitem',
  Column = 'column',
  Section = 'section',
}
